import { Link, Stack, Text } from "@fluentui/react";
import { styles } from "../rolloutDetails.styles";
import useAppInsights from "../../../Hooks/UseAppInsights";
import { NavType } from "../../../Shared/AppInsights";

interface RolloutDetailsLinksProps {
  adoLink?: string;
  ev2Link?: string;
  expLink?: string;
}

const RolloutDetailsLinks: React.FC<RolloutDetailsLinksProps> = ({
  expLink,
}) => {
  const { trackNavigationEvent } = useAppInsights("RolloutDetailsLinks");
  return (
    <Stack horizontal tokens={{ childrenGap: 15 }}>
      <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 5 }}>
        <Text className={styles.rolloutDetailsAccordionHeaderLinks}>
          EXP Studio
        </Text>
        <Link
          title={!expLink ? "EXP Studio link not available" : "Open EXP Studio"}
          href={expLink}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.rolloutDetailsAccordionHeaderLinks}
          disabled={!expLink}
          as={"a"}
          onClick={(e) => {
            if (expLink) {
              e.stopPropagation();
              trackNavigationEvent({
                destination: expLink,
                navType: NavType.External,
              });
            }
          }}
        >
          [EXP]
        </Link>
      </Stack>
    </Stack>
  );
};

export default RolloutDetailsLinks;
